import { render, staticRenderFns } from "./bgList.vue?vue&type=template&id=5a5cb538&scoped=true"
import script from "./bgList.vue?vue&type=script&lang=js"
export * from "./bgList.vue?vue&type=script&lang=js"
import style0 from "./bgList.vue?vue&type=style&index=0&id=5a5cb538&prod&lang=scss"
import style1 from "./bgList.vue?vue&type=style&index=1&id=5a5cb538&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5cb538",
  null
  
)

export default component.exports